import { render, staticRenderFns } from "./Transportation.vue?vue&type=template&id=662d9802&scoped=true"
import script from "./Transportation.vue?vue&type=script&scoped=true&lang=js"
export * from "./Transportation.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Transportation.vue?vue&type=style&index=0&id=662d9802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d9802",
  null
  
)

export default component.exports